import type { DriverRankTierConfigAdminDto } from '@/backend/market'
import { DriverRankTierConfigEntity } from '../../domain/entities/DriverRankTierConfigEntity'
import { DriverRankTierEarningSettingModel } from '@/features/driverEarningSetting/data/models/DriverRankTierEarningSettingModel'
import { mapEntityProperties } from '@/utils/mapEntityProperties'

export class DriverRankTierConfigModel extends DriverRankTierConfigEntity {
  constructor(data: DriverRankTierConfigAdminDto) {
    super()
    mapEntityProperties(this, data, {
      map: {
        driverEarningSetting: data.driverEarningSetting
          ? new DriverRankTierEarningSettingModel(data.driverEarningSetting)
          : null
      }
    })
  }
}
